

export class LocationDto {
    id: number
    locationName: string;
    address: string;
    unitNo: string;
    division: string;
    state: string;
    gpsLocation: string;
    isActive: boolean;
    createdUser: string | null;
    updatedUser: string | null;
    versionFlag: number;
    constructor(
        id: number,
        locationName: string,
        address: string,
        unitNo: string,
        division: string,
        state: string,
        gpsLocation: string,
        isActive: boolean,
        createdUser: string | null,
        updatedUser: string | null,
        versionFlag: number,
    ) {
        this.id = id;
        this.locationName = locationName;
        this.address = address;
        this.unitNo = unitNo;
        this.division = division;
        this.state = state;
        this.gpsLocation = gpsLocation;
        this.isActive = isActive;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
    }




}